export const PROPOSAL_NAME_ERRORS = {
  empty: 'Proposal name cannot be empty',
  tooShort: 'Proposal name must be at least 3 characters',
  tooLong: 'Proposal name must be under 50 characters',
  duplicate: 'Proposal name must be unique'
} as const;

export const validateProposalName = (name: string, existingNames: string[]): true | string => {
  const normalized = name.trim();
  if (!normalized) return PROPOSAL_NAME_ERRORS.empty;
  if (normalized.length < 3) return PROPOSAL_NAME_ERRORS.tooShort;
  if (normalized.length > 50) return PROPOSAL_NAME_ERRORS.tooLong;
  if (existingNames.some((existing) => existing.trim().toLowerCase() === normalized.toLowerCase()))
    return PROPOSAL_NAME_ERRORS.duplicate;
  return true;
};
